export default "\r\n<footer  >\r\n    &copy; All Rights Reserved 2024\r\n</footer>"